export default __webpack_public_path__ + "static/media/lolly3@3x.959065cc.png";